import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en';

import ptTranslations from './locales/pt';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            pt: {
                translation: ptTranslations,
            },
            en: {
                translation: enTranslations,
            },
        },

        fallbackLng: 'pt',

        supportedLngs: ['pt', 'en'],
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',

        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage', 'cookie'],
        },

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;